import { render, staticRenderFns } from "./MessageAttachments.vue?vue&type=template&id=67a5f5f4"
import script from "./MessageAttachments.vue?vue&type=script&lang=js"
export * from "./MessageAttachments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports